import { AppraisalReviewBaseService } from "./appraisalReviewBaseService";

const url = {
  LOAN_DETAILS: '/api/v1/loan/getLoanByIdInternalPortal',
  GET_AUTOMATED_REVIEW_REPORT: '/api/v1/loan/appraisal/getAutomatedAppraisalReviewReport',
  GET_ALL_APPRAISER_FIRM_NAMES: '/api/v1/loan/appraisal/getAllAppraiserFirmNames',
  GET_AUTOMATED_MANUAL_FLAG: '/api/v1/roc-valuation/getValuationAutomatedFlag',
  GET_REPORT_EDITABLE_FLAG: '/api/v1/roc-valuation/getReportEditable',
  GET_APPRAISAL_REVIEW_ITEM_NAMES: '/api/v1/loan/appraisal/getAppraisalReviewItemNames',
  GET_AUTOMATED_REVIEW_PHOTOS: '/api/v1/loan/appraisal/getAutomatedAppraisalReviewPhotos',
  GET_APPRAISAL_REVIEW_VERSION: '/api/v1/loan/appraisal/getAppraisalReviewVersion',
  AUTOMATED_MANUAL_FLAG_BY_LOAN_ID: '/api/v1/loan/appraisal/getAutomatedManualFlagByLoanId',
  GET_SHOULD_SHOW_SECONDARY_VALUATION_FIELDS: '/api/v1/loan/loanToDo/shouldShowSecondaryValuationFields',
  GET_AMC_BY_ID: '/api/v1/roc-valuation/amcLender/getAmcById',
  GET_APPRAISAL_REPORT_STATUS: '/api/v1/roc-valuation/getAppraisalReportStatus'
};

export class AppraisalReviewExternalService extends AppraisalReviewBaseService {

  getAmcById(amcId: number) {
    return this.get(url.GET_AMC_BY_ID, { amcId });
  }

  requestAppraisal1004D(propertyId: number, loanId: number) {
    return null;
  }

  createResolutionPerItem(data: any) {
    return null;
  }

  getAutomatedAppraisalReviewReport(propertyId: number, loanId: number) {
    return this.get(`${url.GET_AUTOMATED_REVIEW_REPORT}?propertyId=${propertyId}&loanId=${loanId}`);
  }

  getLoanDetails(loanId: number) {
    return this.get(url.LOAN_DETAILS, { loanId });
  }

  saveReview(propertyId: number, loanId: number, data: any) {
    return null;
  }

  downloadRevisionListPdf(propertyId: number, data: any) {
    return null;
  }

  approveReport(propertyId: number, loanId: number, valuationType?: string) {
    return null;
  }

  getLoanPropertyValuations(loanId: number, propertyId: number) {
    return null;
  }

  requestRevision(data: any) {
    return null;
  }

  getAllAppraiserFirmNames() {
    return this.get(url.GET_ALL_APPRAISER_FIRM_NAMES);
  }

  getAutomatedManualFlag(loanId: number, propertyId: number) {
    return this.get(url.GET_AUTOMATED_MANUAL_FLAG, {loanId, propertyId});
  }

  getReportEditableFlag(loanId:number, propertyId: number) {
    return this.get(url.GET_REPORT_EDITABLE_FLAG, { loanId, propertyId });
  }

  updateReportEditableFlag(loanId: number, propertyId: number, editable: boolean) {
    return null;
  }

  updateUwAppraisalReviewStatus(loanId: number, propertyId: number, status: string) {
    return null;
  }

  getAppraisalReviewItemNames() {
    return this.get(`${url.GET_APPRAISAL_REVIEW_ITEM_NAMES}`)
  }
  getAutomatedAppraisalReviewPhotos(propertyId: number, loanId: number) {
    return this.get(`${url.GET_AUTOMATED_REVIEW_PHOTOS}?propertyId=${propertyId}&loanId=${loanId}`);
  }

  getAppraisalReviewVersion(propertyId: number, loanId: number) {
    return this.get(`${url.GET_APPRAISAL_REVIEW_VERSION}?propertyId=${propertyId}&loanId=${loanId}`);
  }

  getAutomatedManualFlagByLoanId(loanId: number) {
    return this.get(`${url.AUTOMATED_MANUAL_FLAG_BY_LOAN_ID}?loanId=${loanId}`);
  }

  getShouldShowSecondaryValuationFields(loanId: number, propertyId: number) {
    return this.get(`${url.GET_SHOULD_SHOW_SECONDARY_VALUATION_FIELDS}`, { loanId, propertyId });
  }

  getAppraisalReportStatus(loanId: number, propertyId: number) {
    return this.get(url.GET_APPRAISAL_REPORT_STATUS, {loanId, propertyId});
  }
}